import React, { useState } from "react";
import { Box, Flex, Input, Text, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { AppBar } from "../../../components/mobileUi";
import {
  DesktopBack,
  DesktopButton,
  DesktopPage,
  DesktopPanel,
  useIsDesktop,
} from "../../../components/desktopUi";
import { M } from "../../../components/managementUi";
import { verifyViewAsParticipationApi } from "../../../api/finance.income.api";
import { EMP_BASE_PATH } from "../../../config";

// Bỏ trống mã nhân viên => xem toàn bộ theo vai trò Giám đốc (khớp app).
const DIRECTOR_CODE = "CT01-15";

const Label = ({ title, required }) => (
  <Flex align="center" gap="2px" mb="6px">
    <Text fontSize="14px" fontWeight={500} color={M.baseContent}>
      {title}
    </Text>
    {required ? <Text color={M.red}>*</Text> : null}
  </Flex>
);

// Khớp app: app/(feature)/management/check-transaction/index.tsx
const CheckTransaction = () => {
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();
  const toast = useToast();
  const [apartmentCode, setApartmentCode] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const canSearch = !!apartmentCode.trim();

  const onCheck = async () => {
    const apartment = apartmentCode.trim();
    if (!apartment) return;
    const employee = employeeCode.trim() || DIRECTOR_CODE;

    setSubmitting(true);
    try {
      await verifyViewAsParticipationApi({ employeeCode: employee, apartmentCode: apartment });
      const q = new URLSearchParams({ employeeCode: employee, apartmentCode: apartment });
      navigate(`${EMP_BASE_PATH}/tai-chinh/thu-nhap?${q.toString()}`);
    } catch (e) {
      toast({
        title: e?.message || "Nhân viên này không tham gia giao dịch này, cần kiểm tra lại",
        status: "error",
        duration: 3000,
        position: "top",
      });
    } finally {
      setSubmitting(false);
    }
  };

  // ===================== Bản WEB (desktop) =====================
  if (isDesktop) {
    return (
      <DesktopPage
        title="Kiểm tra giao dịch"
        right={<DesktopBack onClick={() => navigate(-1)} />}
      >
        <DesktopPanel p="24px">
          <Text fontSize="14px" fontWeight={500} color={M.primary} mb="16px">
            Nhập mã căn (bắt buộc) và mã nhân viên để xem giao dịch theo góc nhìn của nhân
            viên đó. Bỏ trống mã nhân viên sẽ xem toàn bộ theo vai trò Giám đốc.
          </Text>

          <Label title="Mã căn" required />
          <Input
            mb="16px"
            h="46px"
            borderRadius="8px"
            bg={M.field}
            border="1px solid"
            borderColor={M.border}
            placeholder="Nhập mã căn"
            value={apartmentCode}
            onChange={(e) => setApartmentCode(e.target.value.toUpperCase())}
          />

          <Label title="Mã nhân viên" />
          <Input
            mb="24px"
            h="46px"
            borderRadius="8px"
            bg={M.field}
            border="1px solid"
            borderColor={M.border}
            placeholder="Nhập mã nhân viên"
            value={employeeCode}
            onChange={(e) => setEmployeeCode(e.target.value.toUpperCase())}
          />

          <DesktopButton
            isDisabled={!canSearch || submitting}
            onClick={() => canSearch && !submitting && onCheck()}
          >
            Tìm kiếm
          </DesktopButton>
        </DesktopPanel>
      </DesktopPage>
    );
  }

  return (
    <Box maxW="480px" mx="auto" pb="100px" minH="100dvh">
      <AppBar title="Kiểm tra giao dịch" />
      <Box px="16px" pt="16px">
        <Text fontSize="14px" fontWeight={500} color={M.primary} mb="16px">
          Nhập mã căn (bắt buộc) và mã nhân viên để xem giao dịch theo góc nhìn của nhân viên đó. Bỏ trống mã nhân viên sẽ
          xem toàn bộ theo vai trò Giám đốc.
        </Text>

        <Label title="Mã căn" required />
        <Input
          mb="16px"
          h="46px"
          borderRadius="8px"
          bg={M.field}
          border="1px solid"
          borderColor={M.border}
          placeholder="Nhập mã căn"
          value={apartmentCode}
          onChange={(e) => setApartmentCode(e.target.value.toUpperCase())}
        />

        <Label title="Mã nhân viên" />
        <Input
          mb="24px"
          h="46px"
          borderRadius="8px"
          bg={M.field}
          border="1px solid"
          borderColor={M.border}
          placeholder="Nhập mã nhân viên"
          value={employeeCode}
          onChange={(e) => setEmployeeCode(e.target.value.toUpperCase())}
        />

      </Box>

      {/* Nút tìm kiếm cố định đáy màn - khớp app */}
      <Box
        position="fixed"
        bottom="0"
        left="50%"
        transform="translateX(-50%)"
        w="100%"
        maxW="480px"
        bg="white"
        px="16px"
        pt="12px"
        pb="16px"
        zIndex={20}
      >
        <Flex
          as="button"
          type="button"
          w="100%"
          h="48px"
          align="center"
          justify="center"
          borderRadius="8px"
          bgImage="var(--color-button)"
          opacity={!canSearch || submitting ? 0.5 : 1}
          cursor={!canSearch || submitting ? "not-allowed" : "pointer"}
          onClick={() => canSearch && !submitting && onCheck()}
        >
          <Text fontSize="16px" fontWeight={700} color="white">
            Tìm kiếm
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};

export default CheckTransaction;
